import { gql } from "@apollo/client";

export default gql`
  query GetStoriesByVendor($vendorId: ObjectId!, $sort: SortType, $cursor: Cursor, $limit: Int = 15) {
    storiesByVendor(vendorId: $vendorId, sort: $sort, cursor: $cursor, limit: $limit) {
      items {
        _id
        title
        slug
        verticalCover
        introduction
        viewerCanRead
        viewerIsAuthor
        viewerDidBookmark
        updatedAt
        modifiedAt
        createdAt
        status
        government {
          _id
          slug
          name
          logo
          isInnovator
          city {
            country
            countryName
          }
        }
        tags {
          _id
          name
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
`;
